const filterSidebar = document.getElementById('filters');

if (filterSidebar) {
    filterSidebar.addEventListener('change', () => {
        filterSidebar.submit();
    });

    const mobileButton = document.getElementById('openMobileFilters');

    mobileButton.addEventListener('click', () => {
        const parent = filterSidebar.parentElement;

        ['fixed', 'h-full', 'w-full', 'top-0', 'left-0', 'bg-white', 'z-20'].forEach(className => parent.classList.add(className));

        parent.style.display = 'block';
    });

    const mobileCloseButton = document.getElementById('closeMobileFilters');

    mobileCloseButton.addEventListener('click', () => {
      const parent = filterSidebar.parentElement;

      ['fixed', 'h-full', 'w-full', 'top-0', 'left-0', 'bg-white', 'z-20'].forEach(className => parent.classList.remove(className));
      parent.style.display = 'none';
    })
}



// WEBPACK FOOTER //
// ./scripts/filters.js